import ProductPropertiesFormField from "./ProductPropertiesFormField";
import ProductPropertiesQueryInformation from "./ProductPropertiesQueryInformation";
import ProductPropertiesRelated, { ProductType } from "./ProductPropertiesRelated";

export enum FormFieldType {
    SINGLESELECT = "SINGLESELECT",
    BOOLEAN = "BOOLEAN", // RADIO = "RADIO",
    CHECKBOX = "CHECKBOX"
}

export enum FormFieldName {
    PAYMENTPERIOD = "paymentPeriod",
    NUMBEROFLICENCES = "numberOfLicences",
    NUMBEROFDAVUSERS = "numberOfDavUsers",
    CUSTOMEROFPRODUCTSPROFDAVSPECKOMM = "customerOfProductsProfDavSpecKomm",
    MEMBEROFDNOTV = "memberOfDNotV",
    PRECONDITIONSELFDISCLOSURE = "preconditionSelfDisclosure",
    PRODUCTVARIANT = "productVariant",
    CUSTOMEROFOTHERPRODUCTS = "customerOfOtherProducts",
    PREMIUM = "premium",
    JOBBRANCH = "jobBranch",
    MUNICIPALEMPLOYEE = "municipalEmployee",
    MEMEBEROFDAV = 'memberOfDav',
    FRAMEWORKCONTRACT = "frameworkContract",
}

/**
 * @example ```json
{
    "magicNumber": "E1F54G",
    "productType": "BASE",
    "professionalContract": "true",
    "relatedProducts": [
        {
            "magicNumber": "A3DK1O",
            "productType": "PREMIUM"
        },
        {
            "magicNumber": "Tt98gscY",
            "productType": "TEST"
        }
    ],
    "configOptions": [
        {
            "name": "paymentPeriod",
            "type": "SINGLESELECT",
            "required": true,
            "value": "1M",
            "choices": [
                "6M",
                "3M",
                "1M",
                "12M"
            ]
        },
        {
            "name": "numberOfLicences",
            "type": "SINGLESELECT",
            "required": true,
            "value": "1",
            "choices": [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10"
            ]
        }
    ]
}
```
 */
export default interface ProductProperties {
    magicNumber: string,
    productType: ProductType,
    professionalContract: boolean,
    title?: string,
    blacklistIds?: string[],
    relatedProducts: Array<ProductPropertiesRelated>,
    configOptions?: Array<ProductPropertiesFormField>,
    queryInformation: ProductPropertiesQueryInformation
}


